var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoSeccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1281,
    height: 587,
    viewBox: "0 0 1281 587",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_344)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 1280,
    height: 587,
    fill: "url(#paint0_linear_104_344)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M154.378 452.482C398.944 452.482 597.203 391.135 597.203 315.459C597.203 239.783 398.944 178.436 154.378 178.436C-90.1869 178.436 -288.446 239.783 -288.446 315.459C-288.446 391.135 -90.1869 452.482 154.378 452.482Z",
    fill: "url(#paint1_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M254.655 427.428C600.748 427.428 881.311 406.481 881.311 380.64C881.311 354.8 600.748 333.853 254.655 333.853C-91.4369 333.853 -372 354.8 -372 380.64C-372 406.481 -91.4369 427.428 254.655 427.428Z",
    fill: "url(#paint2_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M388.338 305.438H332.472L299.538 279.283H251.413L224.237 300.859H81.8097L65.1264 287.595H20.9717V286.22H65.8338L82.5368 299.484H223.529L250.706 277.907H300.265L333.179 304.062H387.631L436.502 265.252H562.364L597.813 237.093H612.079L636.564 217.639H680.856L735.956 173.877L737.175 174.84L681.564 219.015H637.271L612.806 238.449H598.521L563.071 266.608H437.209L388.338 305.438Z",
    fill: "url(#paint3_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M21.1281 289.481C19.3399 289.481 17.8857 288.322 17.8857 286.907C17.8857 285.492 19.3399 284.333 21.1281 284.333C22.9163 284.333 24.3508 285.492 24.3508 286.907C24.3508 288.322 22.8966 289.481 21.1281 289.481Z",
    fill: "url(#paint4_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M738.746 176.274C740.004 175.272 740.004 173.641 738.746 172.639C737.489 171.637 735.425 171.637 734.168 172.639C732.91 173.641 732.91 175.272 734.168 176.274C735.445 177.276 737.489 177.276 738.746 176.274Z",
    fill: "url(#paint5_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M754.525 486.262L717.15 456.57H690.759L644.757 420.02H622.533L591.485 444.701H552.125L513.354 413.889H452.87L423.139 437.509H356.582L322.273 410.254H257.897L250.528 416.11H208.791L190.85 401.863H98.1583L84.3047 412.848H15.292V411.492H83.5973L97.4509 400.487H191.577L209.498 414.734H249.801L257.19 408.878H322.98L357.29 436.133H422.431L452.143 412.533H514.062L552.832 443.325H590.777L621.825 418.664H645.465L691.467 455.194H717.857L755.744 485.299L754.525 486.262Z",
    fill: "url(#paint6_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M15.4494 414.753C13.6612 414.753 12.207 413.614 12.207 412.179C12.207 410.745 13.6612 409.605 15.4494 409.605C17.2376 409.605 18.6917 410.764 18.6917 412.179C18.6917 413.594 17.2376 414.753 15.4494 414.753Z",
    fill: "url(#paint7_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M752.737 487.519C753.995 488.521 756.058 488.521 757.316 487.519C758.574 486.517 758.574 484.886 757.316 483.884C756.058 482.882 753.995 482.882 752.737 483.884C751.46 484.886 751.46 486.517 752.737 487.519Z",
    fill: "url(#paint8_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M883.551 435.249L853.132 411.079H726.563L690.229 382.212H639.295L611.372 360.027H571.147L550.278 376.612H512.097L492.761 361.226H445.521L433.083 371.11H379.103L346.424 345.152H272.538L243.062 368.555H192.285L154.438 338.51H24.5088V337.154H155.165L192.992 367.199H242.355L271.83 343.776H347.131L379.81 369.734H432.375L444.794 359.87H493.469L512.824 375.237H549.571L570.44 358.651H612.079L640.022 380.837H690.937L727.271 409.704H853.84L884.77 434.267L883.551 435.249Z",
    fill: "url(#paint9_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M24.6857 340.416C22.8975 340.416 21.4434 339.256 21.4434 337.841C21.4434 336.426 22.8975 335.267 24.6857 335.267C26.4739 335.267 27.928 336.426 27.928 337.841C27.928 339.256 26.4739 340.416 24.6857 340.416Z",
    fill: "url(#paint10_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M881.743 436.487C883.001 437.489 885.064 437.489 886.341 436.487C887.599 435.484 887.599 433.853 886.341 432.851C885.084 431.849 883.02 431.849 881.743 432.851C880.485 433.853 880.485 435.484 881.743 436.487Z",
    fill: "url(#paint11_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M426.696 351.145H384.329L355.659 328.37H259.941L234.199 348.826H201.874L161.021 316.363H82.1826L63.0037 301.134H25.2354V299.778H63.7111L82.89 315.007H161.728L202.581 347.45H233.472L259.234 326.994H356.366L385.056 349.769H425.969L448.94 331.533H521.883L543.086 348.374H629.135L679.991 307.992H781.152L802.61 290.955L803.809 291.918L781.859 309.368H680.699L629.843 349.749H542.359L521.156 332.909H449.648L426.696 351.145Z",
    fill: "url(#paint12_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M25.3927 303.021C23.6045 303.021 22.1504 301.862 22.1504 300.447C22.1504 299.032 23.6045 297.873 25.3927 297.873C27.1809 297.873 28.6351 299.012 28.6351 300.447C28.6351 301.881 27.1809 303.021 25.3927 303.021Z",
    fill: "url(#paint13_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M805.381 293.352C806.658 292.35 806.658 290.719 805.381 289.717C804.104 288.715 802.06 288.715 800.803 289.717C799.545 290.719 799.545 292.35 800.803 293.352C802.08 294.355 804.123 294.355 805.381 293.352Z",
    fill: "url(#paint14_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M196.372 357.63L162.259 330.551H79.6483L57.2074 312.728H27.2207V311.353H57.9345L80.3754 329.176H162.967L197.591 356.667L196.372 357.63Z",
    fill: "url(#paint15_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.3771 314.614C25.5889 314.614 24.1348 313.455 24.1348 312.04C24.1348 310.625 25.5889 309.466 27.3771 309.466C29.1653 309.466 30.5998 310.625 30.5998 312.04C30.5998 313.455 29.1457 314.614 27.3771 314.614Z",
    fill: "url(#paint16_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M194.564 358.887C195.822 359.889 197.885 359.889 199.163 358.887C200.42 357.885 200.42 356.254 199.163 355.252C197.885 354.249 195.842 354.249 194.564 355.252C193.307 356.254 193.307 357.885 194.564 358.887Z",
    fill: "url(#paint17_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M419.877 338.038H381.558L352.299 314.811H257.288L231.743 335.09H210.5L186.153 315.773L187.372 314.791L211.208 333.734H231.035L256.581 313.435H353.045L382.285 336.682H419.169L447.525 314.162H528.19V315.518H448.232L419.877 338.038Z",
    fill: "url(#paint18_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M184.582 317.188C183.324 316.186 183.324 314.555 184.582 313.553C185.859 312.551 187.903 312.551 189.161 313.553C190.418 314.555 190.418 316.186 189.161 317.188C187.903 318.19 185.84 318.19 184.582 317.188Z",
    fill: "url(#paint19_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M528.033 317.404C529.822 317.404 531.276 316.245 531.276 314.83C531.276 313.415 529.822 312.256 528.033 312.256C526.245 312.256 524.791 313.415 524.791 314.83C524.791 316.245 526.245 317.404 528.033 317.404Z",
    fill: "url(#paint20_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M237.481 313.474H214.392V312.119H236.754L253.948 298.461H302.799V299.817H254.656L237.481 313.474Z",
    fill: "url(#paint21_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M214.568 315.361C212.78 315.361 211.346 314.201 211.346 312.787C211.346 311.372 212.78 310.212 214.568 310.212C216.357 310.212 217.811 311.372 217.811 312.787C217.811 314.201 216.357 315.361 214.568 315.361Z",
    fill: "url(#paint22_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M302.642 301.705C304.43 301.705 305.884 300.565 305.884 299.13C305.884 297.696 304.45 296.556 302.642 296.556C300.834 296.556 299.419 297.716 299.419 299.13C299.419 300.545 300.853 301.705 302.642 301.705Z",
    fill: "url(#paint23_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M399.381 321.414L398.163 320.451L444.951 283.292H591.072L632.142 250.672H715.244L748.67 224.104H791.645L823.145 199.069H881.566V200.445H823.872L792.353 225.48H749.377L715.952 252.028H632.849L591.799 284.647H445.678L399.381 321.414Z",
    fill: "url(#paint24_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M401.19 322.652C399.913 323.654 397.869 323.654 396.592 322.652C395.314 321.649 395.314 320.018 396.592 319.016C397.849 318.014 399.913 318.014 401.19 319.016C402.448 320.018 402.448 321.649 401.19 322.652Z",
    fill: "url(#paint25_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M881.39 202.331C883.178 202.331 884.632 201.172 884.632 199.757C884.632 198.342 883.178 197.183 881.39 197.183C879.602 197.183 878.147 198.342 878.147 199.757C878.147 201.172 879.602 202.331 881.39 202.331Z",
    fill: "url(#paint26_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M418.482 325.972L417.283 324.99L458.805 292.016H539.274L563.385 311.156H610.173L645.878 282.82H739.257V284.176H646.585L610.9 312.531H562.658L538.547 293.372H459.532L418.482 325.972Z",
    fill: "url(#paint27_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M420.289 327.21C419.012 328.212 416.969 328.212 415.691 327.21C414.434 326.208 414.434 324.577 415.691 323.574C416.969 322.572 419.012 322.572 420.289 323.574C421.547 324.577 421.547 326.208 420.289 327.21Z",
    fill: "url(#paint28_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M739.1 286.062C740.888 286.062 742.342 284.903 742.342 283.488C742.342 282.073 740.888 280.914 739.1 280.914C737.311 280.914 735.857 282.073 735.857 283.488C735.857 284.903 737.311 286.062 739.1 286.062Z",
    fill: "url(#paint29_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M598.481 299.817H570.636V298.461H597.753L635.011 268.868H744.838L772.054 247.252H810.746L832.42 230.019L833.638 230.981L811.453 248.628H772.761L745.545 270.243H635.718L598.481 299.817Z",
    fill: "url(#paint30_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M570.793 301.705C569.005 301.705 567.57 300.565 567.57 299.13C567.57 297.696 569.005 296.556 570.793 296.556C572.581 296.556 574.035 297.716 574.035 299.13C574.035 300.545 572.601 301.705 570.793 301.705Z",
    fill: "url(#paint31_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M835.211 232.417C836.489 231.415 836.489 229.784 835.211 228.781C833.954 227.779 831.89 227.779 830.633 228.781C829.375 229.784 829.375 231.415 830.633 232.417C831.91 233.419 833.954 233.419 835.211 232.417Z",
    fill: "url(#paint32_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M625.697 338.136H555.269L536.169 322.966H482.287V321.59H536.876L555.977 336.761H624.97L670.814 300.348H752.148V301.724H671.541L625.697 338.136Z",
    fill: "url(#paint33_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M482.464 324.853C480.656 324.853 479.222 323.693 479.222 322.278C479.222 320.863 480.676 319.704 482.464 319.704C484.252 319.704 485.687 320.863 485.687 322.278C485.687 323.693 484.233 324.853 482.464 324.853Z",
    fill: "url(#paint34_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M751.99 303.61C753.798 303.61 755.233 302.451 755.233 301.036C755.233 299.621 753.798 298.461 751.99 298.461C750.182 298.461 748.748 299.621 748.748 301.036C748.748 302.451 750.202 303.61 751.99 303.61Z",
    fill: "url(#paint35_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M617.581 326.365H560.516L535.678 306.656H467.49V305.28H536.405L561.223 325.009H616.874L658.415 292.016H760.126L799.997 260.339H834.759V261.715H800.704L760.833 293.372H659.122L617.581 326.365Z",
    fill: "url(#paint36_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M467.648 308.542C465.859 308.542 464.425 307.383 464.425 305.968C464.425 304.553 465.879 303.394 467.648 303.394C469.416 303.394 470.89 304.553 470.89 305.968C470.89 307.383 469.455 308.542 467.648 308.542Z",
    fill: "url(#paint37_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M834.602 263.602C836.39 263.602 837.844 262.442 837.844 261.027C837.844 259.613 836.39 258.453 834.602 258.453C832.814 258.453 831.359 259.593 831.359 261.027C831.359 262.462 832.814 263.602 834.602 263.602Z",
    fill: "url(#paint38_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M583.192 275.549H448.39V274.174H582.485L634.52 232.829H688.499L723.104 205.338H778.263L814.636 176.452L815.855 177.415L778.99 206.713H723.831L689.207 234.205H635.247L583.192 275.549Z",
    fill: "url(#paint39_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M448.547 277.436C446.759 277.436 445.324 276.276 445.324 274.861C445.324 273.446 446.778 272.287 448.547 272.287C450.315 272.287 451.789 273.446 451.789 274.861C451.789 276.276 450.335 277.436 448.547 277.436Z",
    fill: "url(#paint40_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M817.427 178.848C818.685 177.846 818.685 176.215 817.427 175.213C816.169 174.211 814.106 174.211 812.848 175.213C811.591 176.215 811.591 177.846 812.848 178.848C814.106 179.851 816.169 179.851 817.427 178.848Z",
    fill: "url(#paint41_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M76.0715 399.957H20.5391V398.601H75.3641L95.4076 382.664H185.328V384.04H96.1347L76.0715 399.957Z",
    fill: "url(#paint42_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M20.6964 401.844C18.9082 401.844 17.4541 400.684 17.4541 399.27C17.4541 397.855 18.9082 396.695 20.6964 396.695C22.4846 396.695 23.9388 397.855 23.9388 399.27C23.9388 400.684 22.4846 401.844 20.6964 401.844Z",
    fill: "url(#paint43_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M185.171 385.926C186.959 385.926 188.413 384.767 188.413 383.352C188.413 381.937 186.959 380.778 185.171 380.778C183.383 380.778 181.948 381.937 181.948 383.352C181.948 384.767 183.402 385.926 185.171 385.926Z",
    fill: "url(#paint44_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M850.027 429.531H686.594L656.018 405.243H621.374L597.518 424.186H562.481L529.94 398.345H450.336L414.159 427.094H359.236L330.349 404.142H217.182L202.365 392.372H126.554V391.016H203.093L217.889 402.767H331.076L359.963 425.718H413.432L449.608 396.989H530.667L563.188 422.83H596.811L620.647 403.887H656.725L687.301 428.175H850.027V429.531Z",
    fill: "url(#paint45_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M126.711 394.258C124.923 394.258 123.469 393.098 123.469 391.684C123.469 390.269 124.923 389.109 126.711 389.109C128.499 389.109 129.934 390.269 129.934 391.684C129.934 393.098 128.48 394.258 126.711 394.258Z",
    fill: "url(#paint46_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M849.87 431.437C851.658 431.437 853.113 430.278 853.113 428.863C853.113 427.448 851.658 426.289 849.87 426.289C848.082 426.289 846.628 427.429 846.628 428.863C846.628 430.298 848.082 431.437 849.87 431.437Z",
    fill: "url(#paint47_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M845.253 422.005H721.867L681.8 390.171H629.195L612.08 376.592H579.558L565.056 388.108H504.768L488.89 375.492H474.074L460.947 385.926H378.592L345.638 359.752H288.082L264.206 378.715H207.73V377.359H263.499L287.374 358.396H346.345L379.299 384.571H460.24L473.366 374.136H489.598L505.475 386.732H564.329L578.831 375.217H612.807L629.903 388.795H682.527L722.574 420.629H845.253V422.005Z",
    fill: "url(#paint48_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M207.887 380.601C206.099 380.601 204.645 379.442 204.645 378.027C204.645 376.612 206.099 375.453 207.887 375.453C209.675 375.453 211.129 376.612 211.129 378.027C211.129 379.442 209.675 380.601 207.887 380.601Z",
    fill: "url(#paint49_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M845.095 423.891C846.883 423.891 848.337 422.732 848.337 421.317C848.337 419.902 846.903 418.743 845.095 418.743C843.287 418.743 841.872 419.902 841.872 421.317C841.872 422.732 843.307 423.891 845.095 423.891Z",
    fill: "url(#paint50_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M174.835 375.688H92.539L75.3645 362.031H27.2207V360.656H76.0719L93.2661 374.313H174.835V375.688Z",
    fill: "url(#paint51_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M27.3771 363.918C25.5889 363.918 24.1348 362.758 24.1348 361.343C24.1348 359.928 25.5889 358.769 27.3771 358.769C29.1653 358.769 30.5998 359.928 30.5998 361.343C30.5998 362.758 29.1457 363.918 27.3771 363.918Z",
    fill: "url(#paint52_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M174.658 377.575C176.447 377.575 177.881 376.415 177.881 375.001C177.881 373.586 176.427 372.426 174.658 372.426C172.89 372.426 171.416 373.586 171.416 375.001C171.416 376.415 172.87 377.575 174.658 377.575Z",
    fill: "url(#paint53_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M163.359 360.891H103.523L85.8574 346.861H19.5762V345.485H86.5845L104.25 359.516H163.359V360.891Z",
    fill: "url(#paint54_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M19.7336 348.748C17.9454 348.748 16.4912 347.608 16.4912 346.173C16.4912 344.739 17.9454 343.599 19.7336 343.599C21.5218 343.599 22.9759 344.758 22.9759 346.173C22.9759 347.588 21.5218 348.748 19.7336 348.748Z",
    fill: "url(#paint55_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M163.201 362.777C164.99 362.777 166.424 361.618 166.424 360.203C166.424 358.788 164.99 357.629 163.201 357.629C161.413 357.629 159.959 358.788 159.959 360.203C159.959 361.618 161.393 362.777 163.201 362.777Z",
    fill: "url(#paint56_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M417.401 405.852H386.943L346.581 373.782H297.16L280.457 387.066H218.224V385.69H279.73L296.452 372.426H347.308L387.651 404.476H417.401V405.852Z",
    fill: "url(#paint57_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M218.381 388.952C216.593 388.952 215.158 387.793 215.158 386.378C215.158 384.963 216.612 383.804 218.381 383.804C220.149 383.804 221.623 384.963 221.623 386.378C221.623 387.793 220.189 388.952 218.381 388.952Z",
    fill: "url(#paint58_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M417.244 407.739C419.032 407.739 420.487 406.579 420.487 405.165C420.487 403.75 419.032 402.59 417.244 402.59C415.456 402.59 414.021 403.75 414.021 405.165C414.021 406.579 415.456 407.739 417.244 407.739Z",
    fill: "url(#paint59_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M370.417 409.802L337.03 383.273H305.275L289.044 396.164H228.736V394.808H288.336L304.548 381.898H337.757L371.635 408.819L370.417 409.802Z",
    fill: "url(#paint60_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M228.894 398.051C227.105 398.051 225.651 396.891 225.651 395.477C225.651 394.062 227.105 392.902 228.894 392.902C230.682 392.902 232.136 394.062 232.136 395.477C232.136 396.891 230.682 398.051 228.894 398.051Z",
    fill: "url(#paint61_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M368.629 411.039C369.906 412.042 371.95 412.042 373.227 411.039C374.504 410.037 374.504 408.406 373.227 407.404C371.969 406.402 369.906 406.402 368.629 407.404C367.371 408.406 367.371 410.037 368.629 411.039Z",
    fill: "url(#paint62_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M637.192 361.619L635.974 360.656L677.515 327.662H789.719L823.833 300.584L825.051 301.547L790.446 329.038H678.222L637.192 361.619Z",
    fill: "url(#paint63_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M639 362.856C637.743 363.858 635.679 363.858 634.402 362.856C633.145 361.854 633.145 360.223 634.402 359.221C635.679 358.219 637.723 358.219 639 359.221C640.258 360.223 640.258 361.854 639 362.856Z",
    fill: "url(#paint64_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M826.623 302.981C827.881 301.979 827.881 300.348 826.623 299.346C825.366 298.344 823.302 298.344 822.045 299.346C820.787 300.348 820.787 301.979 822.045 302.981C823.302 303.983 825.366 303.983 826.623 302.981Z",
    fill: "url(#paint65_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M911.69 419.076L879.503 393.511H845.606L829.826 380.994H795.202L777.065 395.417H730.513L698.993 370.382H648V369.007H699.701L731.24 394.042H776.357L794.495 379.618H830.553L846.313 392.155H880.23L912.909 418.113L911.69 419.076Z",
    fill: "url(#paint66_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M648.157 372.269C646.369 372.269 644.915 371.11 644.915 369.695C644.915 368.28 646.369 367.121 648.157 367.121C649.946 367.121 651.4 368.28 651.4 369.695C651.4 371.11 649.946 372.269 648.157 372.269Z",
    fill: "url(#paint67_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M909.883 420.334C911.16 421.336 913.204 421.336 914.481 420.334C915.738 419.332 915.738 417.701 914.481 416.699C913.204 415.697 911.16 415.697 909.883 416.699C908.625 417.701 908.625 419.332 909.883 420.334Z",
    fill: "url(#paint68_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M778.028 362.601H749.849L726.701 344.209H684.904L665.843 359.34L664.625 358.377L684.197 342.833H727.408L750.576 361.226H777.301L799.172 343.875H830.79L848.829 329.549L850.067 330.512L831.497 345.25H799.86L778.028 362.601Z",
    fill: "url(#paint69_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M667.651 360.597C666.374 361.599 664.33 361.599 663.053 360.597C661.795 359.595 661.795 357.964 663.053 356.962C664.31 355.959 666.374 355.959 667.651 356.962C668.909 357.964 668.909 359.595 667.651 360.597Z",
    fill: "url(#paint70_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M851.619 331.946C852.876 330.944 852.876 329.313 851.619 328.311C850.361 327.309 848.298 327.309 847.04 328.311C845.763 329.313 845.763 330.944 847.04 331.946C848.317 332.948 850.361 332.948 851.619 331.946Z",
    fill: "url(#paint71_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M818.134 336.997H767.377V335.621H817.427L855.097 305.693L856.315 306.656L818.134 336.997Z",
    fill: "url(#paint72_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M767.534 338.883C765.746 338.883 764.292 337.724 764.292 336.309C764.292 334.894 765.746 333.735 767.534 333.735C769.323 333.735 770.757 334.894 770.757 336.309C770.757 337.724 769.303 338.883 767.534 338.883Z",
    fill: "url(#paint73_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M857.887 308.09C859.164 307.088 859.164 305.457 857.887 304.455C856.63 303.453 854.566 303.453 853.309 304.455C852.031 305.457 852.031 307.088 853.309 308.09C854.566 309.092 856.63 309.092 857.887 308.09Z",
    fill: "url(#paint74_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M794.259 370.756H726.21L712.376 359.751H683.332V358.396H713.083L726.937 369.38H793.552L810.019 356.313H844.172L893.907 316.795L895.126 317.758L844.879 357.669H810.746L794.259 370.756Z",
    fill: "url(#paint75_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M683.488 361.638C681.7 361.638 680.246 360.479 680.246 359.064C680.246 357.649 681.7 356.49 683.488 356.49C685.277 356.49 686.731 357.649 686.731 359.064C686.731 360.479 685.277 361.638 683.488 361.638Z",
    fill: "url(#paint76_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M896.678 319.193C897.955 318.19 897.955 316.559 896.678 315.557C895.42 314.555 893.357 314.555 892.099 315.557C890.842 316.559 890.842 318.19 892.099 319.193C893.377 320.195 895.42 320.195 896.678 319.193Z",
    fill: "url(#paint77_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M768.851 384.413H729.078L713.338 371.915L714.556 370.933L729.805 383.037H768.851V384.413Z",
    fill: "url(#paint78_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M711.766 373.33C710.509 372.328 710.509 370.697 711.766 369.695C713.024 368.693 715.087 368.693 716.345 369.695C717.603 370.697 717.603 372.328 716.345 373.33C715.087 374.333 713.044 374.333 711.766 373.33Z",
    fill: "url(#paint79_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M768.693 386.299C770.482 386.299 771.936 385.14 771.936 383.725C771.936 382.31 770.482 381.151 768.693 381.151C766.905 381.151 765.471 382.31 765.471 383.725C765.471 385.14 766.905 386.299 768.693 386.299Z",
    fill: "url(#paint80_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M881.566 483.786H833.186L824.108 476.574H771.582L732.419 445.487H690.976V444.111H733.146L772.289 475.218H824.835L833.894 482.43H881.566V483.786Z",
    fill: "url(#paint81_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M691.133 447.374C689.345 447.374 687.891 446.214 687.891 444.799C687.891 443.384 689.345 442.225 691.133 442.225C692.921 442.225 694.375 443.384 694.375 444.799C694.375 446.214 692.921 447.374 691.133 447.374Z",
    fill: "url(#paint82_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M881.39 485.672C883.178 485.672 884.632 484.513 884.632 483.098C884.632 481.683 883.178 480.524 881.39 480.524C879.602 480.524 878.147 481.683 878.147 483.098C878.147 484.513 879.602 485.672 881.39 485.672Z",
    fill: "url(#paint83_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M911.16 469.559H834.857L826.978 463.31H783.53L749.614 436.37H701.489V435.014H750.321L784.238 461.935H827.685L835.565 468.203H911.16V469.559Z",
    fill: "url(#paint84_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M701.626 438.275C699.838 438.275 698.403 437.116 698.403 435.701C698.403 434.286 699.857 433.127 701.626 433.127C703.395 433.127 704.868 434.286 704.868 435.701C704.868 437.116 703.414 438.275 701.626 438.275Z",
    fill: "url(#paint85_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M911.003 471.465C912.791 471.465 914.245 470.305 914.245 468.891C914.245 467.476 912.791 466.316 911.003 466.316C909.215 466.316 907.761 467.476 907.761 468.891C907.761 470.305 909.195 471.465 911.003 471.465Z",
    fill: "url(#paint86_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M861.778 460.245L839.396 442.441H785.515V441.085H840.104L863.016 459.282L861.778 460.245Z",
    fill: "url(#paint87_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M785.692 444.327C783.903 444.327 782.449 443.168 782.449 441.753C782.449 440.338 783.903 439.179 785.692 439.179C787.48 439.179 788.934 440.338 788.934 441.753C788.934 443.168 787.48 444.327 785.692 444.327Z",
    fill: "url(#paint88_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M859.99 461.482C861.248 462.484 863.311 462.484 864.569 461.482C865.846 460.48 865.846 458.849 864.569 457.847C863.311 456.845 861.248 456.845 859.99 457.847C858.732 458.849 858.732 460.48 859.99 461.482Z",
    fill: "url(#paint89_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M711.216 174.172H644.385L613.828 149.903H545.641L528.25 163.737H450.473L425.144 143.615H326.812V142.613H425.674L450.984 162.735H527.72L545.13 148.901H614.339L644.915 173.169H710.705L747.354 144.067H858.949V145.069H747.884L711.216 174.172Z",
    fill: "url(#paint90_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M326.95 145.384C325.378 145.384 324.101 144.362 324.101 143.105C324.101 141.847 325.378 140.845 326.95 140.845C328.522 140.845 329.799 141.867 329.799 143.105C329.799 144.343 328.522 145.384 326.95 145.384Z",
    fill: "url(#paint91_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M858.811 146.839C860.383 146.839 861.66 145.817 861.66 144.579C861.66 143.341 860.383 142.299 858.811 142.299C857.239 142.299 855.962 143.321 855.962 144.579C855.962 145.836 857.239 146.839 858.811 146.839Z",
    fill: "url(#paint92_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M249.802 447.531H171.082L115.039 403.022H80.7484L68.7027 412.572H29.3623V411.57H68.1917L80.2179 402.02H115.569L171.613 446.528H249.271L268.116 431.555H383.504L418.246 403.965H518.268L552.813 431.398H796.421V432.4H552.283L517.737 404.968H418.777L384.035 432.557H268.627L249.802 447.531Z",
    fill: "url(#paint93_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M29.5192 414.342C27.9472 414.342 26.6699 413.32 26.6699 412.082C26.6699 410.844 27.9472 409.802 29.5192 409.802C31.0913 409.802 32.3882 410.824 32.3882 412.082C32.3882 413.339 31.1109 414.342 29.5192 414.342Z",
    fill: "url(#paint94_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M796.263 434.168C797.835 434.168 799.113 433.146 799.113 431.908C799.113 430.67 797.835 429.628 796.263 429.628C794.691 429.628 793.414 430.65 793.414 431.908C793.414 433.166 794.691 434.168 796.263 434.168Z",
    fill: "url(#paint95_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M729.688 490.231H587.771L534.597 447.982H409.679V446.98H535.128L588.302 489.229H729.688V490.231Z",
    fill: "url(#paint96_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M409.816 449.751C408.244 449.751 406.967 448.729 406.967 447.472C406.967 446.214 408.244 445.212 409.816 445.212C411.388 445.212 412.685 446.234 412.685 447.472C412.685 448.71 411.388 449.751 409.816 449.751Z",
    fill: "url(#paint97_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M729.55 492C731.122 492 732.399 490.978 732.399 489.72C732.399 488.463 731.122 487.46 729.55 487.46C727.978 487.46 726.7 488.482 726.7 489.72C726.7 490.958 727.978 492 729.55 492Z",
    fill: "url(#paint98_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M540.944 105.631V121.607H520.822V105.631H540.944ZM542.988 104H518.798V123.218H542.988V104Z",
    fill: "url(#paint99_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M573.151 105.631V121.607H553.029V105.631H573.151ZM575.175 104H550.985V123.218H575.175V104Z",
    fill: "url(#paint100_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M669.753 105.631V121.607H649.631V105.631H669.753ZM671.796 104H647.587V123.218H671.796V104Z",
    fill: "url(#paint101_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M540.944 130.214V146.209H520.822V130.214H540.944ZM542.988 128.603H518.798V147.821H542.988V128.603Z",
    fill: "url(#paint102_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M605.358 130.214V146.209H585.236V130.214H605.358ZM607.402 128.603H583.212V147.821H607.402V128.603Z",
    fill: "url(#paint103_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M637.565 130.214V146.209H617.443V130.214H637.565ZM639.589 128.603H615.399V147.821H639.589V128.603Z",
    fill: "url(#paint104_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M669.753 130.214V146.209H649.631V130.214H669.753ZM671.796 128.603H647.587V147.821H671.796V128.603Z",
    fill: "url(#paint105_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.0717 429.63V447.374H8.72901V429.63H31.0717ZM32.7616 428.293H7.03906V448.73H32.7616V428.293Z",
    fill: "url(#paint106_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M65.3031 429.63V447.374H42.9605V429.63H65.3031ZM66.993 428.293H41.2705V448.73H66.993V428.293Z",
    fill: "url(#paint107_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M99.5346 429.63V447.374H77.1919V429.63H99.5346ZM101.225 428.293H75.502V448.73H101.225V428.293Z",
    fill: "url(#paint108_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M133.765 429.63V447.374H111.422V429.63H133.765ZM135.455 428.293H109.732V448.73H135.455V428.293Z",
    fill: "url(#paint109_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.996 429.63V447.374H145.654V429.63H167.996ZM169.686 428.293H143.964V448.73H169.686V428.293Z",
    fill: "url(#paint110_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M202.228 429.63V447.374H179.885V429.63H202.228ZM203.918 428.293H178.195V448.73H203.918V428.293Z",
    fill: "url(#paint111_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M270.671 429.63V447.374H248.329V429.63H270.671ZM272.361 428.293H246.639V448.73H272.361V428.293Z",
    fill: "url(#paint112_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M304.921 429.63V447.374H282.559V429.63H304.921ZM306.592 428.293H280.869V448.73H306.592V428.293Z",
    fill: "url(#paint113_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M339.153 429.63V447.374H316.791V429.63H339.153ZM340.823 428.293H315.101V448.73H340.823V428.293Z",
    fill: "url(#paint114_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M373.384 429.63V447.374H351.022V429.63H373.384ZM375.074 428.293H349.352V448.73H375.074V428.293Z",
    fill: "url(#paint115_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M407.616 429.63V447.374H385.273V429.63H407.616ZM409.306 428.293H383.583V448.73H409.306V428.293Z",
    fill: "url(#paint116_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M441.827 429.63V447.374H419.484V429.63H441.827ZM443.516 428.293H417.794V448.73H443.516V428.293Z",
    fill: "url(#paint117_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M476.058 429.63V447.374H453.715V429.63H476.058ZM477.748 428.293H452.025V448.73H477.748V428.293Z",
    fill: "url(#paint118_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M544.52 429.63V447.374H522.177V429.63H544.52ZM546.21 428.293H520.487V448.73H546.21V428.293Z",
    fill: "url(#paint119_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M578.751 429.63V447.374H556.409V429.63H578.751ZM580.441 428.293H554.719V448.73H580.441V428.293Z",
    fill: "url(#paint120_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M612.983 429.63V447.374H590.64V429.63H612.983ZM614.673 428.293H588.95V448.73H614.673V428.293Z",
    fill: "url(#paint121_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.0717 455.764V473.509H8.72901V455.764H31.0717ZM32.7616 454.428H7.03906V474.865H32.7616V454.428Z",
    fill: "url(#paint122_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M99.5346 455.764V473.509H77.1919V455.764H99.5346ZM101.225 454.428H75.502V474.865H101.225V454.428Z",
    fill: "url(#paint123_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M133.765 455.764V473.509H111.422V455.764H133.765ZM135.455 454.428H109.732V474.865H135.455V454.428Z",
    fill: "url(#paint124_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.996 455.764V473.509H145.654V455.764H167.996ZM169.686 454.428H143.964V474.865H169.686V454.428Z",
    fill: "url(#paint125_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M202.228 455.764V473.509H179.885V455.764H202.228ZM203.918 454.428H178.195V474.865H203.918V454.428Z",
    fill: "url(#paint126_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M236.459 455.764V473.509H214.117V455.764H236.459ZM238.149 454.428H212.427V474.865H238.149V454.428Z",
    fill: "url(#paint127_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M270.671 455.764V473.509H248.329V455.764H270.671ZM272.361 454.428H246.639V474.865H272.361V454.428Z",
    fill: "url(#paint128_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M304.921 455.764V473.509H282.559V455.764H304.921ZM306.592 454.428H280.869V474.865H306.592V454.428Z",
    fill: "url(#paint129_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M339.153 455.764V473.509H316.791V455.764H339.153ZM340.823 454.428H315.101V474.865H340.823V454.428Z",
    fill: "url(#paint130_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M373.384 455.764V473.509H351.022V455.764H373.384ZM375.074 454.428H349.352V474.865H375.074V454.428Z",
    fill: "url(#paint131_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M407.616 455.764V473.509H385.273V455.764H407.616ZM409.306 454.428H383.583V474.865H409.306V454.428Z",
    fill: "url(#paint132_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M441.827 455.764V473.509H419.484V455.764H441.827ZM443.516 454.428H417.794V474.865H443.516V454.428Z",
    fill: "url(#paint133_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M476.058 455.764V473.509H453.715V455.764H476.058ZM477.748 454.428H452.025V474.865H477.748V454.428Z",
    fill: "url(#paint134_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M510.289 455.764V473.509H487.947V455.764H510.289ZM511.979 454.428H486.257V474.865H511.979V454.428Z",
    fill: "url(#paint135_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M544.52 455.764V473.509H522.177V455.764H544.52ZM546.21 454.428H520.487V474.865H546.21V454.428Z",
    fill: "url(#paint136_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M612.983 455.764V473.509H590.64V455.764H612.983ZM614.673 454.428H588.95V474.865H614.673V454.428Z",
    fill: "url(#paint137_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M647.214 455.764V473.509H624.852V455.764H647.214ZM648.904 454.428H623.182V474.865H648.904V454.428Z",
    fill: "url(#paint138_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-99.6434 380.444H-210.197V378.557H-100.626L-87.853 368.418H-48.4538L-6.55881 335.13H195.783L247.365 294.158L249.036 295.494L196.765 337.016H-5.55664L-47.4712 370.304H-86.8902L-99.6434 380.444Z",
    fill: "url(#paint139_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M244.908 292.449C246.638 291.073 249.448 291.073 251.197 292.449C252.945 293.824 252.945 296.064 251.197 297.44C249.448 298.815 246.638 298.815 244.908 297.44C243.159 296.064 243.159 293.824 244.908 292.449Z",
    fill: "url(#paint140_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M46.4577 421.199H-71.583V419.313H45.4752L98.4727 377.221H299.832L376.449 316.383H664.152V318.27H377.412L300.814 379.108H99.4552L46.4577 421.199Z",
    fill: "url(#paint141_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M663.917 320.864C666.373 320.864 668.377 319.272 668.377 317.327C668.377 315.381 666.373 313.79 663.917 313.79C661.46 313.79 659.476 315.381 659.476 317.327C659.476 319.272 661.46 320.864 663.917 320.864Z",
    fill: "url(#paint142_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M55.0257 337.095L53.3555 335.778L110.519 290.366H210.226L244.673 262.993H528.309V264.879H245.656L211.228 292.233H111.501L55.0257 337.095Z",
    fill: "url(#paint143_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M528.073 267.472C530.529 267.472 532.514 265.88 532.514 263.935C532.514 261.99 530.51 260.398 528.073 260.398C525.636 260.398 523.632 261.97 523.632 263.935C523.632 265.9 525.617 267.472 528.073 267.472Z",
    fill: "url(#paint144_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M115.333 336.643L113.663 335.307L137.499 316.383H175.661V318.27H138.482L115.333 336.643Z",
    fill: "url(#paint145_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M175.444 320.864C177.9 320.864 179.885 319.272 179.885 317.327C179.885 315.381 177.881 313.79 175.444 313.79C173.007 313.79 171.003 315.381 171.003 317.327C171.003 319.272 172.988 320.864 175.444 320.864Z",
    fill: "url(#paint146_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M336.146 350.791H279.612L255.756 331.848L257.426 330.512L280.574 348.905H336.146V350.791Z",
    fill: "url(#paint147_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M259.882 328.802C258.153 327.427 255.323 327.427 253.594 328.802C251.845 330.178 251.845 332.418 253.594 333.793C255.323 335.169 258.153 335.169 259.882 333.793C261.631 332.418 261.631 330.178 259.882 328.802Z",
    fill: "url(#paint148_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M329.721 396.714H212.171L190.045 379.147L191.715 377.81L213.134 394.828H328.738L401.956 336.662H509.032V338.549H402.958L329.721 396.714Z",
    fill: "url(#paint149_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M508.815 341.143C511.271 341.143 513.256 339.551 513.256 337.605C513.256 335.66 511.252 334.068 508.815 334.068C506.378 334.068 504.374 335.66 504.374 337.605C504.374 339.551 506.359 341.143 508.815 341.143Z",
    fill: "url(#paint150_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M462.774 289.56H311.406L280.221 264.8L281.891 263.464L312.389 287.693H462.774V289.56Z",
    fill: "url(#paint151_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M462.558 292.153C465.015 292.153 466.999 290.562 466.999 288.616C466.999 286.671 464.995 285.079 462.558 285.079C460.122 285.079 458.098 286.671 458.098 288.616C458.098 290.562 460.102 292.153 462.558 292.153Z",
    fill: "url(#paint152_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M478.456 317.601L476.766 316.265L498.322 299.169H615.007V301.036H499.305L478.456 317.601Z",
    fill: "url(#paint153_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M651.773 380.463L625.5 359.594H455.444L428.602 338.273L430.272 336.937L456.427 357.708H626.482L653.463 379.146L651.773 380.463Z",
    fill: "url(#paint154_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-147.689 370.304H-194.398L-218.844 350.889L-217.173 349.553L-193.416 368.417H-148.652L-57.6111 296.103H8.86661L79.6871 239.844H173.735V241.73H80.6696L9.84914 297.99H-56.6286L-147.689 370.304Z",
    fill: "url(#paint155_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-78.7944 351.165H-124.089V349.298H-79.7769L-39.7881 317.523H0.299006V319.409H-38.8056L-78.7944 351.165Z",
    fill: "url(#paint156_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M138.481 275.785H37.3008V273.899H137.499L158.446 257.255H216.022L225.808 249.493L227.498 250.809L216.985 259.141H159.429L138.481 275.785Z",
    fill: "url(#paint157_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M80.6494 316.343H47.8919L32.2305 303.905L33.9007 302.568L48.8548 314.477H80.6494V316.343Z",
    fill: "url(#paint158_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M565.684 259.082L548.411 245.366H362.222L336.46 224.89H226.142L183.619 258.669L181.948 257.352L225.16 223.023H337.443L363.205 243.479H549.394L567.334 257.745L565.684 259.082Z",
    fill: "url(#paint159_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M329.74 321.747L319.109 313.298H226.143V311.411H320.092L331.43 320.411L329.74 321.747Z",
    fill: "url(#paint160_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M334.535 244.836H280.28L254.911 224.674L256.581 223.358L281.263 242.969H334.535V244.836Z",
    fill: "url(#paint161_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M443.242 302.667H375.369L358.882 289.58L360.572 288.244L376.351 300.781H443.242V302.667Z",
    fill: "url(#paint162_radial_104_344)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M405.846 244.914L404.176 243.578L445.599 210.683H619.998L651.792 185.432L653.462 186.768L620.98 212.569H446.582L405.846 244.914Z",
    fill: "url(#paint163_radial_104_344)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_104_344",
    x1: 641,
    y1: 0,
    x2: 641,
    y2: 587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1426",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192308,
    stopColor: "#0E1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884615,
    stopColor: "#0E1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975962,
    stopColor: "#0E1426",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.639 304.497) scale(442.67 136.016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#054073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#011237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.772 390.8) scale(625.674 46.9874)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#054073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#011237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#000020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(380.404 238.158) scale(260.598 205.735)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4841 285.237) scale(3.24823 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(738.739 173.164) scale(3.24825 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(386.877 441.17) scale(265.28 209.431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7944 410.079) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(757.377 483.349) scale(3.24825 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(456.188 384.187) scale(308.112 243.246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0469 335.994) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(886.746 432.486) scale(3.2482 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(415.954 319.264) scale(277.332 218.946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7633 298.731) scale(3.24824 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(805.585 289.853) scale(3.24819 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.018 332.669) scale(63.8446 50.4036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7568 310.279) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.696 355.147) scale(3.24823 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(358.449 323.932) scale(121.753 96.1205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.682 313.604) scale(3.24825 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(529.754 313.073) scale(3.24825 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.591 304.231) scale(32.0567 25.3079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.46 311.04) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.767 297.423) scale(3.24824 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(641.897 258.673) scale(179.862 141.997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(400.274 319.052) scale(3.24823 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(884.104 198.383) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.136 302.657) scale(115.771 91.3985)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(419.426 323.596) scale(3.24823 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.405 281.842) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(704.352 263.324) scale(98.2982 77.6039)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(572.653 297.423) scale(3.24821 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(835.492 229.121) scale(3.24825 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(619.204 317.46) scale(97.1334 76.6842)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(484.078 320.484) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(754.33 299.314) scale(3.24822 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(653.187 291.674) scale(133.491 105.388)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(469.225 304.231) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(837.172 259.451) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(634.146 224.54) scale(137.568 108.607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(450.072 273.246) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(817.66 175.728) scale(3.24819 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.519 389.28) scale(58.9386 46.5305)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0592 397.222) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.979 381.358) scale(3.24824 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(489.925 408.186) scale(257.058 202.941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.355 389.669) scale(3.24823 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(852.495 426.704) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(528.232 388.167) scale(227.802 179.844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.739 376.052) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(847.7 419.187) scale(3.24827 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.593 366.237) scale(52.7558 41.6493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7568 359.427) scale(3.24824 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.429 373.028) scale(3.24821 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.0273 351.292) scale(51.4341 40.6058)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0959 344.307) scale(3.24824 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.936 358.295) scale(3.24824 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.978 387.123) scale(72.178 56.9826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(219.291 384.364) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(418.688 403.093) scale(3.24824 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.303 393.808) scale(52.1733 41.1895)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.82 393.455) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.227 407.125) scale(3.24823 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(732.802 329.274) scale(72.3572 57.1241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(638.739 359.127) scale(3.2482 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(826.867 299.438) scale(3.24819 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(782.893 392.004) scale(96.5509 76.2244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(650.23 367.74) scale(3.24822 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(914.972 416.392) scale(3.2482 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(759.708 344.201) scale(67.384 53.1979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(667.458 356.863) scale(3.24826 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(851.957 328.301) scale(3.24825 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(814.367 319.565) scale(34.4985 27.2356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(769.922 334.474) scale(3.24821 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(858.229 304.531) scale(3.24825 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(791.674 341.901) scale(78.8537 62.2529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(685.647 357.164) scale(3.24828 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(897.141 315.602) scale(3.24825 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(743.421 375.698) scale(20.5871 16.253)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(716.315 369.561) scale(3.24819 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(771.087 381.729) scale(3.24827 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(788.717 461.685) scale(69.8482 55.1433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(693.309 442.585) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(884.104 480.768) scale(3.24822 2.56439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(808.812 450.048) scale(75.919 59.9361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(703.86 433.512) scale(3.24827 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(913.786 466.584) scale(3.24822 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(826.8 448.439) scale(28.7637 22.7082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(788.135 439.56) scale(3.24822 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(864.928 457.405) scale(3.24825 2.5644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(594.787 157.158) scale(189.182 149.354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.14 141.949) scale(2.86743 2.26374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(861.433 143.382) scale(2.86737 2.26374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(414.319 422.635) scale(272.695 215.285)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9075 409.973) scale(2.86739 2.26374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(798.731 429.744) scale(2.86737 2.26375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(571.534 466.3) scale(115.077 90.8503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.228 445.255) scale(2.86741 2.26374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(731.839 487.364) scale(2.86743 2.26374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532.644 112.538) scale(12.1417 9.58553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(564.925 112.538) scale(12.1193 9.56785)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(661.789 112.538) scale(12.1417 9.58553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532.644 137.05) scale(12.1417 9.58553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(597.205 137.05) scale(12.1193 9.56784)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(629.508 137.05) scale(12.1416 9.58553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(661.789 137.05) scale(12.1417 9.58553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2525 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5719 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.8914 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.232 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.552 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.871 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.51 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.829 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(329.148 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.49 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397.81 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(432.128 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(466.448 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(535.108 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(569.428 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(603.747 436.325) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2525 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.8914 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.232 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.552 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.871 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.191 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.51 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.829 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(329.148 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.49 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(397.81 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(432.128 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(466.448 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(500.79 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(535.108 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(603.747 462.375) scale(12.9033 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(638.089 462.375) scale(12.9034 10.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7824 335.464) scale(167.295 132.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(249.017 293.248) scale(4.45793 3.51941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.405 366.838) scale(264.989 209.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(666.046 315.55) scale(4.45795 3.51942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.917 298.342) scale(171.596 135.471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(529.822 262.351) scale(4.45791 3.51941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.343 324.711) scale(23.7681 18.7643)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.212 315.55) scale(4.45794 3.51942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.047 338.806) scale(29.9061 23.6101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.754 329.486) scale(4.45793 3.51942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(350.789 364.751) scale(116.22 91.7522)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(510.489 335.764) scale(4.45791 3.5194)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(372.809 274.891) scale(65.7711 51.9246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(464.118 286.952) scale(4.45792 3.51942)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(547.676 306.636) scale(49.6868 39.2264)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(542.792 356.792) scale(82.057 64.7819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-22.3105 303.346) scale(150.875 119.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-61.7597 332.528) scale(46.5729 36.7681)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.044 261.061) scale(68.4369 54.0292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9009 307.715) scale(18.2349 14.396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.967 239.537) scale(137.568 108.607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(279.842 314.807) scale(37.6123 29.6939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(295.815 232.605) scale(29.8165 23.5394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(402.469 293.762) scale(30.6006 24.1584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_104_344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(530.561 213.752) scale(92.2722 72.8465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C2C2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1281,
    height: 587,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoSeccion);
export default __webpack_public_path__ + "static/media/fondo_seccion.92982fc0a868b46f94fe7153c6d2ab6c.svg";
export { ForwardRef as ReactComponent };